import React from "react";
import { Link } from "react-router-dom";

function Partner() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>파트너</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">파트너</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="featureStyle1">
        <div className="auto-container">
          <div className="sec-title mt-30">
            <h2>AI / Big Data / IoT 서비스</h2>
          </div>
          <div className="row clearfix parter">
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/client-01-01.png" alt=""/>
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/client-01-03.png" alt=""/>
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/kt.png" alt=""/>
            </div>
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-02.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-04.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-05.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-06.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-07.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-08.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-09.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-10.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-11.png"> </div> --> */}
            {/* <!-- <div className="col-md-3 col-sm-4 col-xs-6"><img src="../images/nexmore/client/client-01-12.png"> </div> --> */}
          </div>
          <br />
          <div className="sec-title mt-30">
            <h2>공공</h2>
          </div>
          <div className="row clearfix parter">
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/5.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/6.jpg" alt=""/>
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/8.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/4.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/15.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/14.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/7.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/3.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/11.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/1.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/2.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/12.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/13.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/9.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/19.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/16.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/17.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/18.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/10.jpg" alt="" />
            </div>
          </div>
          <br />
          <div className="sec-title mt-30">
            <h2>스마트 팩토리</h2>
          </div>
          <div className="row clearfix parter">
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/mira.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/sfa.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/client-03-01.png"  alt=""/>
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/client-03-03.png"  alt=""/>
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/et.jpg" alt="" />
            </div>
          </div>
          <br />
          <div className="sec-title mt-30">
            <h2>협력사</h2>
          </div>
          <div className="row clearfix parter">
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/yoon.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/kb.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/adt.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/meta.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/ga.png" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/lotte.jpg" alt="" />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <img src="../images/nexmore/client/han.jpg" alt="" />
            </div>
          </div>
          <br />
        </div>
      </section>
    </div>
  );
}

export default Partner;
